
import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { toast } from "@/hooks/use-toast";
import Layout from "@/components/Layout";
import ResultsSummary from "@/components/ResultsSummary";
import { QuizResult } from "@/types";

const ResultsPage: React.FC = () => {
  const navigate = useNavigate();
  const [result, setResult] = useState<QuizResult | null>(null);
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    // Get result from sessionStorage
    const storedResult = sessionStorage.getItem('quizResult');
    
    if (storedResult) {
      try {
        setResult(JSON.parse(storedResult));
      } catch (error) {
        console.error("Error parsing quiz result:", error);
        toast({
          title: "Error loading results",
          description: "There was a problem loading your assessment results.",
          variant: "destructive",
        });
        navigate('/quiz');
      } finally {
        setIsLoading(false);
      }
    } else {
      // If no result found, redirect to the quiz page with a message
      toast({
        title: "No assessment results found",
        description: "Please complete the assessment to view results.",
        variant: "destructive",
      });
      navigate('/quiz');
    }
  }, [navigate]);

  if (isLoading) {
    return (
      <Layout>
        <div className="section bg-gray-50">
          <div className="container-custom">
            <div className="text-center py-12">
              <p className="text-lg">Loading results...</p>
            </div>
          </div>
        </div>
      </Layout>
    );
  }

  return (
    <Layout>
      <div className="section bg-gray-50">
        <div className="container-custom">
          <div className="max-w-4xl mx-auto py-12">
            {result && (
              <ResultsSummary 
                result={result} 
                onRestart={() => navigate('/quiz')} 
              />
            )}
          </div>
        </div>
      </div>
    </Layout>
  );
};

export default ResultsPage;
